export default __webpack_public_path__ + "static/media/Password-generator.2ccaf8e3.png";